import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import { LAB_SANDBOX_PATH_PART_NAME } from 'bundles/launched-lab/utils/LabSandboxUtils';

const LabSandboxPage = loadOnRoute(() => import('bundles/labs/components/LabSandboxPage'));

export default (
  <Route>
    <Route path={LAB_SANDBOX_PATH_PART_NAME} name="labSandbox" getComponent={LabSandboxPage} />
  </Route>
);
